<!--
  冻结的旧服务端兼容页面：用于 Level 0 或尚未确认服务端能力的兼容分支。
  对齐 APP 冻结边界：除旧接口契约变化、兼容性缺陷、严重安全问题或阻断性缺陷外，
  不调整本页布局、交互和请求逻辑；不得同步新版搜索、筛选、候选分页等功能。
  新版功能只在 modern-region.vue 中维护，不得改用新版接口或通过请求失败探测能力。
  必要修复保留旧接口及参数语义，并回归旧服务加载、选择/控制、保存和返回链路。
  本页依赖共享组件及公共样式；修改这些依赖时也需检查旧服务兼容分支。
-->
<template>
  <div>
    <view-title :titleName="asseregionProps.sceneTitleName"></view-title>
    <scene-view :sceneList="ServeData.sceneList" viewType="region"></scene-view>
    <view-title :titleName="asseregionProps.deviceTitleName"></view-title>
    <device-view listOwner="region" :deviceList="ServeData.deviceList"></device-view>
    <!-- <h2>{{this.$store.state.publicinfo.title}}</h2> -->
  </div>
</template>

<script>
import { regionPageDataRequest } from "views/afterLogin/control/control_public_request_js";
import ViewTitle from "components/content/contro-view/view-title";
import SceneView from "components/content/contro-view/scene-view/scene-view";
import DeviceView from "components/content/contro-view/device-view/device-view";
import { objectClone } from "common/tool";
import { createSocket, closeSoket } from "common/webSoket";

export default {
  name: "Region",
  components: {
    ViewTitle,
    SceneView,
    DeviceView
  },
  data() {
    return {
      regionRequestVersion: 0,
      asseregionProps: {
        ////决定title组件显示形式的变量值
        sceneTitleName: "场景",
        deviceTitleName: "设备"
      },
      ServeData: {
        deviceList: [],
        sceneList: []
      }
    };
  },
  watch: {
    "$store.state.publicinfo.regionServeData": {
      handler(newValue, oldValue) {
        console.log("区域页面数据发生了改变1");
        console.log(newValue);

        this.ServeData = newValue;
      },
      deep: true //深度监听,监听数组的第二层数据变化
    }
  },
  beforeCreate() {
    ///钩子函数：vue实例的挂载元素$el和数据对象data都为undefined，还未初始化。
  },
  created() {
    ///钩子函数: vue实例的数据对象data有了，$el还没有
    console.log("region被创建了");
    createSocket(this); //创建 soket

    ////区域的页面数据的刷新，异步请求服务器
    //  regionPageDataRequest.then((res)=>{
    //     this.ServeData =res;
    // });
    // console.log(this.ServeData);
  },
  beforeMount() {
    ///钩子函数: vue实例的$el和data都初始化了，但还是虚拟的dom节点，具体的data.filter还未替换。
  },
  activated() {
    console.log("region被激活了");
    createSocket(this); // 作用域替换时，旧组件的销毁可能已关闭共享连接。
    ////区域的页面数据的刷新，异步请求服务器  传入要显示的区域ID 在仓库里存着
    const version = ++this.regionRequestVersion;
    regionPageDataRequest(this.$store.state.publicinfo.regionShowPage.id).then(
      res => {
        if (this._isDestroyed || version !== this.regionRequestVersion) return;
        this.ServeData = res;
        // let paiXuServeData = {}
        // objectClone(paiXuServeData, this.ServeData)
        // this.$store.dispatch('asyUpdataServeData', res) ///异步提交当前页面需要展示的控制数据,用于排序

        this.$store.dispatch("asyUpdataregionServeData", this.ServeData); ///异步提交当前页面需要展示的控制数据,用于状态更新
        this.$store.dispatch(
          "asyUpdataregionSceneCount",
          this.ServeData.sceneList.length
        ); ///异步提交得到的数组长度
        console.log(
          "区域页面请求得到服务器的场景总个数" + this.ServeData.sceneList.length
        );

        // 排序功能实现

        console.log(this.ServeData);
      }
    ).catch(error => {
      if (!error.stale && !this._isDestroyed) console.log(error);
    });
  },
  mounted() {
    //vue实例挂载完成，data.filter成功渲染  一般数据请求放在这里
    console.log("region被渲染成功了");
  },
  beforeDestroy() {
    ////组件销毁前调用
    console.log("region被销毁前");
    closeSoket(); ///关闭soket
  },
  destroyed() {
    console.log("region被销毁后");
  }
};
</script>

<style></style>
